import React from 'react';
import Icon from '@/components/ui/AppIcon';

const levels = [
  { id: 'yesil', name: 'Yeşil', min: 0, max: 299, color: 'bg-green-400', benefits: ['Doğum günü içeceği', 'Ücretsiz Wi-Fi', 'Özel teklifler'] },
  { id: 'altin', name: 'Altın', min: 300, max: 599, color: 'bg-gold', benefits: ['Yeşil avantajları +', 'Aylık ücretsiz içecek', 'Öncelikli hazırlama', 'Free Mod Mondays'] },
  { id: 'reserve', name: 'Reserve', min: 600, max: 999, color: 'bg-amber-700', benefits: ['Altın avantajları +', 'Reserve Bar erişimi', 'Özel tatlar', 'VIP etkinlikler'] },
] as const;

interface LevelProgressProps {
  stars: number;
}

export default function LevelProgress({ stars }: LevelProgressProps) {
  const currentLevel = levels.find((l) => stars >= l.min && stars <= l.max) || levels[0];
  const progressPct = Math.min(100, ((stars - currentLevel.min) / (currentLevel.max - currentLevel.min)) * 100);

  return (
    <div className="px-4 py-4 bg-card border-b border-border">
      {/* Level badges */}
      <div className="flex items-center justify-between mb-4">
        {levels.map((level, i) => {
          const isActive = level.id === currentLevel.id;
          const isPast = levels.indexOf(currentLevel) > i;
          return (
            <div key={`level-${level.id}`} className="flex flex-col items-center gap-1 flex-1">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all ${
                  isActive
                    ? `${level.color} border-transparent text-white`
                    : isPast
                    ? 'bg-primary border-primary text-white' :'bg-muted border-border text-muted-foreground'
                }`}
              >
                {isPast ? (
                  <Icon name="CheckIcon" size={18} className="text-white" />
                ) : (
                  <Icon name="StarIcon" size={18} variant={isActive ? 'solid' : 'outline'} className={isActive ? 'text-white' : 'text-muted-foreground'} />
                )}
              </div>
              <span className={`text-[10px] font-bold ${isActive ? 'text-foreground' : 'text-muted-foreground'}`}>
                {level.name}
              </span>
              <span className="text-[9px] text-muted-foreground">{level.min}–{level.max}★</span>
            </div>
          );
        })}
      </div>

      {/* Progress bar */}
      <div className="relative mb-3">
        <div className="h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-700"
            style={{ width: `${progressPct}%` }}
          />
        </div>
        <div
          className="absolute -top-1 w-4 h-4 bg-primary rounded-full border-2 border-white card-shadow transition-all duration-700"
          style={{ left: `calc(${progressPct}% - 8px)` }}
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-muted-foreground text-xs">{stars} ★ toplam</span>
        <span className="text-primary text-xs font-semibold">
          {currentLevel.max - stars} ★ kaldı → {levels[Math.min(levels.indexOf(currentLevel) + 1, levels.length - 1)].name}
        </span>
      </div>

      {/* Current level benefits */}
      <div className="mt-3 bg-muted rounded-xl p-3">
        <p className="text-foreground font-semibold text-xs mb-2">
          {currentLevel.name} Üye Avantajlarınız
        </p>
        <div className="space-y-1">
          {currentLevel.benefits.map((b) => (
            <div key={`benefit-${currentLevel.id}-${b}`} className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={14} variant="solid" className="text-primary flex-shrink-0" />
              <span className="text-muted-foreground text-xs">{b}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}